module.exports = __webpack_public_path__ + "img/umb41_uv_sleeve-01.811c7145.svg";